export const strMainHeadline = "Erfassung einer Klassenarbeit";
export const strToolName = "Unterrichtsentwicklung mit Ergebnissen von Klassenarbeiten";
export const strToolNameHeadline = strToolName;
export const strVersion = "Version 71.230.1110";

export const default_toast_showtime = 5000;
export const default_tooltip_show = 150;
export const default_tooltip_hide = 100;

export const title_evaluation = "Klassenarbeit auswerten und analysieren";
export const str_no_exams_available = "Sie haben noch keine Klassenarbeit im System hinterlegt.";

export const criteria = [
    "Durchschnittlicher Lösungsgrad in einer Klasse",
    "Abstand der Lösungsgrade in einer Klasse",
    "Unterschied im Lösungsgrad zwischen mehreren Klassen"
];

export const criteria_tooltips = [
    // "Der durchschnittliche Lösungsgrad einzelner Aufgaben unterschreitet 20% und/oder überschreitet 80%.",
    "Der durchschnittliche Lösungsgrad einzelner Aufgaben unterschreitet 20% oder überschreitet 80%.",
    "Der Lösungsgrad der Aufgaben untereinander überschreitet 40%.",
    "Der relative Abstand einzelner Aufgaben überschreitet 20%."
];

export const linkOESDGSE = "https://www.schule-bw.de/themen-und-impulse/oes/02-dgse/index.html";
// export const linkDPImprint = "https://examer.examer.de?open=";
export const linkDPImprint = "/?open=";


